import { useEffect } from 'react';
import { reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';

import { ResetBtn, UseBtn } from 'libs/ui';
import { DictFilter, Container, Input, ButtonsContainer } from 'libs/form';

const initial = { is_active: ['true'] };

const Filter = (props) => {
  const { setInitial, reset, handleSubmit, theme } = props;

  const { t } = useTranslation();

  // did mount
  useEffect(() => {
    setInitial(initial);
    return () => {
      reset();
      setInitial(initial);
    };
  }, []);

  return (
    <Container theme={theme}>
      <form onSubmit={handleSubmit}>
        <DictFilter w={140} dict="users.status" multiple />

        <Input width="220px" name="username" type="text" label={t('form.Логин')} placeholder={t('form.Введите текст для поиска')} />

        <Input width="220px" name="name" type="text" label={t('form.ФИО')} placeholder={t('form.Введите текст для поиска')} />

        <Input width="220px" name="email" type="text" label={t('form.E-mail')} placeholder={t('form.Введите текст для поиска')} />

        <ButtonsContainer>
          <ResetBtn onClick={reset} theme={theme} />
          <UseBtn />
        </ButtonsContainer>
      </form>
    </Container>
  );
};

export default reduxForm({
  form: 'usersFilter',
  // destroyOnUnmount: false,
  initialValues: initial,
})(Filter);
